export default "__VITE_ASSET__CkL3BZfT__"